export default __webpack_public_path__ + "static/tips-72d5d8758e1095ecab56ca56305101f6.pdf";